import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipeVideoPlugin from 'photoswipe/video-plugin';

class VideoLightbox extends HTMLElement {
  /** @type {PhotoSwipeLightbox | null} */
  #lightbox = null;

  connectedCallback() {
    this.#lightbox = new PhotoSwipeLightbox({
      gallery: this,
      children: 'a[data-pswp-type="video"]',
      pswpModule: () => import('photoswipe'),
      bgOpacity: 1,
      zoom: false,
      counter: false,
      closeSVG:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><line x1="5.39757" y1="5.23526" x2="18.8326" y2="18.6703" stroke="#0B0A09" stroke-linecap="round"/><line x1="4.92856" y1="18.3643" x2="18.3636" y2="4.92929" stroke="#0B0A09" stroke-linecap="round"/></svg>',
    });

    new PhotoSwipeVideoPlugin(this.#lightbox, {
      autoplay: true,
    });

    this.#lightbox.init();
  }

  disconnectedCallback() {
    this.#lightbox?.destroy();
    this.#lightbox = null;
  }
}

if (!customElements.get('video-lightbox')) {
  customElements.define('video-lightbox', VideoLightbox);
}
